function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from 'react';
import ContextActionUtils from "../context-actions/ContextActionUtils.js";
import ContextMenuItem from "../context-actions/ContextMenuItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *  Do not use this class directly. Use DropdownMenu instead.
 *
 *  Generates list from actions for use by DropdownMenu.
 *  It has beem split from the context-actions component, due to divergering requirements,
 *  but still re-uses styling from context-menu. Depending on how usage evolves, may get split further.
 *
 */

class Menu extends PureComponent {
  constructor(props) {
    var _options$initialKeybo;
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "oldFocus", void 0);
    _defineProperty(this, "rAF", void 0);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMenuItemClick = this.handleMenuItemClick.bind(this);
    this.handleMenuItemMouseMove = this.handleMenuItemMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.container = /*#__PURE__*/React.createRef();
    this.oldFocus = document.activeElement;
    this.rAF = 0;
    var options = props.options;
    var keyboardIndex = (_options$initialKeybo = options.initialKeyboardIndex) !== null && _options$initialKeybo !== void 0 ? _options$initialKeybo : -1;
    this.state = {
      menuItems: [],
      keyboardIndex,
      mouseIndex: -1
    };
  }
  componentDidMount() {
    this.initMenu();
    this.rAF = window.requestAnimationFrame(() => {
      var _this$container$curre;
      // set initial focus to container so keyboard navigation works
      // components can still override focus in onMenuOpened callback
      (_this$container$curre = this.container.current) === null || _this$container$curre === void 0 || _this$container$curre.focus();
      var onMenuOpened = this.props.onMenuOpened;
      onMenuOpened(this);
    });
  }
  componentDidUpdate(prevProps) {
    var actions = this.props.actions;
    if (prevProps.actions !== actions) {
      this.initMenu();
    }
  }
  componentWillUnmount() {
    cancelAnimationFrame(this.rAF);
  }
  getKeyboardIndex() {
    var options = this.props.options;
    if (options.separateKeyboardMouse !== undefined && options.separateKeyboardMouse) {
      var keyboardIndex = this.state.keyboardIndex;
      return keyboardIndex;
    }
    return this.getMouseIndex();
  }
  setKeyboardIndex(index) {
    var options = this.props.options;
    if (options.separateKeyboardMouse !== undefined && options.separateKeyboardMouse) {
      this.setState({
        keyboardIndex: index
      });
    } else {
      this.setMouseIndex(index);
    }
  }
  getMouseIndex() {
    var mouseIndex = this.state.mouseIndex;
    return mouseIndex;
  }
  setMouseIndex(index) {
    this.setState({
      mouseIndex: index
    });
  }
  initMenu() {
    // cancel any pending close
    cancelAnimationFrame(this.rAF);
    this.setState({
      menuItems: []
    });
    var actions = this.props.actions;
    var menuItems = ContextActionUtils.getMenuItems(actions, false);
    if (menuItems.length > 0) {
      this.setState(state => ({
        menuItems: ContextActionUtils.sortActions(state.menuItems.concat(menuItems))
      }));
    }
  }
  handleKeyDown(e) {
    var menuItems = this.state.menuItems;
    var oldFocus = this.getKeyboardIndex();
    var newFocus = oldFocus;
    if (e.key === 'Enter' || e.key === ' ') {
      if (oldFocus != null && oldFocus >= 0 && oldFocus < menuItems.length) {
        this.handleMenuItemClick(menuItems[oldFocus], e);
      }
      return;
    }
    if (e.key === 'Escape') {
      newFocus = null;
    } else if (e.key === 'ArrowUp' || e.key === 'Tab' && e.shiftKey === true) {
      newFocus = ContextActionUtils.getNextMenuItem(newFocus !== null && newFocus !== void 0 ? newFocus : 0, -1, menuItems);
    } else if (e.key === 'ArrowDown' || e.key === 'Tab' && e.shiftKey === false) {
      newFocus = ContextActionUtils.getNextMenuItem(newFocus !== null && newFocus !== void 0 ? newFocus : 0, 1, menuItems);
    }
    if (oldFocus !== newFocus) {
      if (newFocus !== null) {
        this.setKeyboardIndex(newFocus);
      } else {
        this.closeMenu();
        if (this.oldFocus instanceof HTMLElement) {
          this.oldFocus.focus();
        }
      }
      e.preventDefault();
      e.stopPropagation();
    }
  }
  closeMenu() {
    var closeAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _this$props = this.props,
      closeMenu = _this$props.closeMenu,
      onMenuClosed = _this$props.onMenuClosed;
    cancelAnimationFrame(this.rAF);
    this.rAF = window.requestAnimationFrame(() => {
      closeMenu(closeAll);
      onMenuClosed(this);
    });
  }
  handleCloseMenu() {
    this.closeMenu();
  }
  handleMenuItemClick(menuItem, e) {
    e.preventDefault();
    e.stopPropagation();
    if (menuItem != null && (menuItem.disabled === undefined || !menuItem.disabled) && menuItem.action != null) {
      menuItem.action(e.nativeEvent);
      this.closeMenu(true);
    }
  }
  handleMenuItemMouseMove(menuItem) {
    var menuItems = this.state.menuItems;
    var focusIndex = menuItems.indexOf(menuItem);
    this.setMouseIndex(focusIndex);
  }
  handleMouseLeave() {
    this.setMouseIndex(-1);
  }
  render() {
    var menuItemElements = [];
    var dataTestId = this.props['data-testid'];
    var _this$state = this.state,
      keyboardIndex = _this$state.keyboardIndex,
      menuItems = _this$state.menuItems,
      mouseIndex = _this$state.mouseIndex;
    for (var i = 0; i < menuItems.length; i += 1) {
      var menuItem = menuItems[i];
      if (i > 0 && menuItem.group !== menuItems[i - 1].group) {
        menuItemElements.push(/*#__PURE__*/_jsx("hr", {}, "".concat(i, ".separator")));
      }
      var menuItemElement = /*#__PURE__*/_jsx(ContextMenuItem, {
        isKeyboardSelected: keyboardIndex === i,
        isMouseSelected: mouseIndex === i,
        menuItem: menuItem,
        closeMenu: this.handleCloseMenu,
        onMenuItemClick: this.handleMenuItemClick,
        onMenuItemMouseMove: this.handleMenuItemMouseMove,
        onMenuItemContextMenu: () => false
      }, i);
      menuItemElements.push(menuItemElement);
    }
    var menuStyle = this.props.menuStyle;
    return /*#__PURE__*/_jsx("div", {
      className: "context-menu-container",
      style: _objectSpread({}, menuStyle),
      ref: this.container,
      onKeyDown: this.handleKeyDown,
      onMouseLeave: this.handleMouseLeave,
      role: "menuitem",
      tabIndex: 0,
      "data-testid": dataTestId,
      children: menuItemElements
    });
  }
}
_defineProperty(Menu, "defaultProps", {
  closeMenu() {
    // no-op
  },
  onMenuOpened() {
    // no-op
  },
  onMenuClosed() {
    // no-op
  },
  options: {},
  menuStyle: {},
  'data-testid': undefined
});
export default Menu;
//# sourceMappingURL=Menu.js.map